import styles from './styles.module.css';

type Props = {
  label: string;
  name: string;
  value: string;
  disabled?: boolean;
  defaultCheck?: boolean;
  onClick?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ChipsRadioSmall = ({ label, name, value, disabled, defaultCheck, onClick, onChange }: Props) => {
  const chipsIsDisabled = disabled ? styles.boxChipsRadioLabelDisabled : '';

  return (
    <label className={`${styles.boxChipsRadioSmallLabel} ${chipsIsDisabled}`} onChange={onClick}>
      <input
        type="radio"
        className={styles.boxChipsRadioLabelInput}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultCheck}
      />
      <span className={styles.boxChipsRadioSmallLabelSpan}></span>

      <span className={styles.boxChipsRadioSmallLabelContent}>{label}</span>
    </label>
  );
};

export default ChipsRadioSmall;
